import cn from "classnames";
import * as React from "react";
import FormLabel from "./form-label";

interface Props {
  children?: React.ReactNode;
  className?: string;
  label?: React.ReactNode;
  isRequired?: boolean;
  id?: string;
}

const FormGroup: React.FC<Props> = ({
  className,
  children,
  label,
  isRequired,
  id,
}) => {
  const classes = cn("form-group", className);
  return (
    <div className={classes} id={id}>
      {label &&
        (typeof label === "string" ? (
          <FormLabel>
            {label}
            {isRequired && <span className="form-required">*</span>}
          </FormLabel>
        ) : (
          label
        ))}
      {children}
    </div>
  );
};

FormGroup.displayName = "Form.Group";

export default FormGroup;
